import type { Theme } from '@repo/theme';
import type { Theme as NavigationTheme } from 'expo-router/react-navigation';

// Builds the React Navigation themes from the resolved design tokens, so
// partner silo overrides reach the navigation chrome. The transparent variant
// lets the host page show through widgets.
export function getNavigationThemes(tokens: Theme) {
    const defaultNavigationTheme: NavigationTheme = {
        // Application themes do not currently declare light/dark.
        dark: false,
        colors: {
            background: tokens.colors.colorSurfaceSecondary,
            border: tokens.colors.colorBorderPrimary,
            card: tokens.colors.colorSurfacePrimary,
            notification: tokens.colors.colorTagAccent,
            primary: tokens.colors.colorTextPrimary,
            text: tokens.colors.colorTextPrimary,
        },
        fonts: {
            regular: {
                fontFamily: tokens.fonts.fontFamilySansRegular,
                fontWeight: '400',
            },
            medium: {
                fontFamily: tokens.fonts.fontFamilySansMedium,
                fontWeight: '500',
            },
            bold: {
                fontFamily: tokens.fonts.fontFamilySansSemiBold,
                fontWeight: '600',
            },
            // Reuse the bold font. The application does not have a heavy font.
            heavy: {
                fontFamily: tokens.fonts.fontFamilySansSemiBold,
                fontWeight: '600',
            },
        },
    };
    const transparentNavigationTheme: NavigationTheme = {
        ...defaultNavigationTheme,
        colors: {
            ...defaultNavigationTheme.colors,
            background: 'transparent',
        },
    };
    return { defaultNavigationTheme, transparentNavigationTheme };
}
